<template>
    <Modal v-model="show"
        :width="1200"
        :footer-hide="true"
        title="现售报损"
        @on-visible-change="onShowChange">
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="18">
                <Row :gutter="16">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm"
                        :table-load-event="getDiscardTableRecord"
                        :table-search="mainTable.tableSearch"
                        :colSpan="6" />
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="24">
                    <stand-pagination-table :columns="mainTable.columns"
                        :data="storeList"
                        :autoHeight="true"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getDiscardTableRecord" />
                    </Col>
                </Row>
                </Col>
                <Col span="6">
                <Row :gutter="16"
                    class="row-margin-top-15">
                    <Col span="24">
                    <Form label-position="top"
                        class="small-form">
                        <Row :gutter="16">
                            <Col span="24">
                            <FormItem label="视频">
                                <single-file-upload-with-name v-model="discard.form.video"
                                    :format="['mp4','jpg']" />
                            </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="24">
                            <FormItem label="备注">
                                <Input v-model="discard.form.remark"
                                    type="textarea"
                                    :rows="4"></Input>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="24"
                                style="text-align:right;">
                            <Button type="primary"
                                :loading="btnLoading"
                                @click="submitDiscard">提交报损</Button>
                            </Col>
                        </Row>
                    </Form>
                    </Col>
                </Row>
                </Col>
            </Row>
        </Card>
    </Modal>
</template>

<script>
import { currencyRender, dateRender } from '@/libs/tableRowTimeRender';
import CurrencyInput from '@/components/number-input/currency-input';
import search from '@/libs/search';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import SearchCard from '@/components/searchCard/searchCard.vue';

import {
    curSaleStoreDiscard,
    curSaleUpdateAdjustPrice,
    getCurSaleWarehouseProductStore
} from '@/api/modules/warehouse-management/warehouse';

export default {
    name: 'CurSaleWarehouseDiscardEdit',
    components: {
        CurrencyInput,
        SingleFileUploadWithName,
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            show: false,
            mainTable: {
                columns: [
                    { title: '仓库', key: 'warehouseName', align: 'center' },
                    { title: '产品编号', key: 'productCode', width: 80, align: 'center' },
                    { title: '产品名称', key: 'productName', align: 'center' },
                    { title: '批次号', key: 'warehouseProductStoreBatchCode', width: 80, align: 'center' },
                    { title: '仓存量', key: 'warehouseProductStoreAmount', width: 80, align: 'center' },
                    { title: '过鲜日期', key: 'warehouseProductStoreExpireDate', width: 80, align: 'center', render: (h, params) => dateRender(h, params.row.warehouseProductStoreExpireDate) },
                    { title: '定价阶段', key: 'warehouseProductStoreStep', width: 80, align: 'center' },
                    { title: '最新价', key: 'warehouseProductStoreBatchPrice', width: 80, align: 'right', render: (h, params) => currencyRender(h, params.row.warehouseProductStoreBatchPrice) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            const isDiscardElement = h('Checkbox', {
                                props: {
                                    value: params.row.isDiscard,
                                    trueValue: true,
                                    falseValue: false
                                },
                                style: {
                                    width: '30px',
                                    float: 'left',
                                    marginTop: '6px'
                                },
                                on: {
                                    'on-change': checked => {
                                        this.storeList[params.index].isDiscard = checked;
                                    }
                                }
                            }, '');

                            const amountElement = h('Input', {
                                props: {
                                    value: params.row.discardAmount,
                                    disabled: !params.row.isDiscard,
                                    max: params.row.warehouseProductStoreAmount,
                                    type: 'number'
                                },
                                style: {
                                    float: 'left',
                                    width: 'calc(100% - 60px)'
                                },
                                on: {
                                    'on-keyup': event => {
                                        let floatVal = parseFloat(event.target.value);
                                        if (floatVal < 0) {
                                            floatVal = 0;
                                        }
                                        if (floatVal > params.row.warehouseProductStoreAmount) {
                                            floatVal = params.row.warehouseProductStoreAmount;
                                        }
                                        event.target.value = floatVal;
                                        this.storeList[params.index].discardAmount = floatVal;
                                    }
                                }
                            });

                            return h('div', [
                                isDiscardElement,
                                amountElement
                            ]);
                        }
                    }
                ],
                tableSearch: search.getSearchParams(),
                loading: false,
                searchForm: [
                    { label: '商品名称', type: 'Input', value: '', name: 'productName', sql: 'like' },
                    { label: '商品编码', type: 'Input', value: '', name: 'productCode', sql: 'like' }
                ]
            },
            storeList: [],
            discard: {
                form: {
                    remark: '',
                    video: '',
                    products: []
                }
            },
            btnLoading: false
        };
    },
    mounted() {
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.discard.form.remark = '';
            this.discard.form.video = '';
            this.discard.form.products = [];
            this.getDiscardTableRecord();
        },
        getDiscardTableRecord() {
            this.mainTable.loading = true;
            this.mainTable.tableSearch.amountFilter = 1;
            getCurSaleWarehouseProductStore(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    this.storeList = res.data.records.map(s => {
                        return Object.assign(s, {
                            isDiscard: false,
                            discardAmount: 0
                        });
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        submitDiscard() {
            this.discard.form.products = this.storeList.filter(s => s.isDiscard);

            if (this.discard.form.products.length === 0) {
                this.$Modal.error({ title: '出错啦', content: '请先选择需要报损的产品' });
                return;
            }

            const hasEmpty = this.discard.form.products.find(s => s.discardAmount <= 0);
            if (hasEmpty) {
                this.$Modal.error({ title: '出错啦', content: '报损产品必须设置报损数量' });
                return;
            }

            if (!this.discard.form.video) {
                this.$Modal.error({ title: '出错啦', content: '请先上传报损视频' });
                return;
            }

            this.mainTable.loading = true;
            this.btnLoading = true;
            curSaleStoreDiscard(this.discard.form).then(res => {
                this.mainTable.loading = false;
                this.btnLoading = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '报损成功',
                        onOk: () => {
                            this.show = false;
                            this.$parent.init();
                        }
                    });
                }
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style scoped>
#discardTable /deep/ input[type="number"]::-webkit-inner-spin-button,
#discardTable /deep/ input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
